import { render, staticRenderFns } from "./ActivityDetails.vue?vue&type=template&id=6e193ed2"
import script from "./ActivityDetails.vue?vue&type=script&lang=js"
export * from "./ActivityDetails.vue?vue&type=script&lang=js"
import style0 from "./ActivityDetails.vue?vue&type=style&index=0&id=6e193ed2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports